import { useEffect as h } from "react";
const m = 50;
function T(e, o, d = []) {
  h(() => {
    if (!e.current) return;
    let n = null, u, i = 0;
    const c = (t, r = !1) => {
      if (n && n.height === t.height && n.width === t.width)
        return;
      clearTimeout(u);
      const l = Date.now();
      if (!r || l - i >= m) {
        n = t, i = l, o(t, e);
        return;
      }
      u = setTimeout(() => {
        n = t, i = Date.now(), o(t, e);
      }, m);
    }, s = new ResizeObserver((t) => {
      const r = t[0];
      r && c(r.contentRect, !0);
    });
    return c(e.current.getBoundingClientRect()), s.observe(e.current), () => {
      clearTimeout(u), s.disconnect();
    };
  }, [e, o, ...d]);
}
export {
  T as useSize
};
//# sourceMappingURL=useSize.js.map
